<template>
  <div>
    <md-field class="procedure-category">
      <md-select
        v-model="state.category"
        v-close-on-zoom
        :disabled="readonly"
        @md-selected="selectCategory"
      >
        <md-option
          v-for="category in procedureCategorires"
          :key="category.key"
          :value="category.key"
        >
          {{ category.label.en }}
        </md-option>
      </md-select>
    </md-field>
    <md-field class="clothes-type">
      <md-select
        id="expose-select"
        v-model="state.clothing"
        v-close-on-zoom
        placeholder="Any"
        class="expose-select"
        :disabled="readonly"
        @md-selected="setClothing"
      >
        <md-option
          v-for="clothing in filteredClothing"
          :key="clothing.key"
          :value="clothing.key"
        >
          {{ clothing.label.en }}
        </md-option>
      </md-select>
    </md-field>
  </div>
</template>

<script>
import get from 'lodash/get';

import clothing from '~lib/common/config/clothing';

export default {
  name: 'expose-action',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      procedureCategorires: [
        { key: 'REMOVED', label: { en: 'Removed' }},
        { key: 'REPLACED', label: { en: 'Replaced' }},
      ],
      state: {
        category: 'REMOVED',
        clothing: null,
      },
    };
  },
  computed: {
    filteredClothing() {
      return clothing
        .filter(item => {
          if (item.key === this.state.clothing) {
            return true; // have to display, because user has selected it
          }
          if (item.key === 'UPPER_UNDERWEAR') {
            return this.hasUpperUnderwear;
          }
          if (item.outfitRestrictions) {
            return item.outfitRestrictions.includes(this.patientClothing);
          }
          return true;
        });
    },
    patientClothing() {
      return get(this.emitter.caseConf, 'outfit.clothingType');
    },
    hasUpperUnderwear() {
      return get(this.emitter.caseConf._avatar, 'avatarOptions.upperUnderwear');
    },
  },
  mounted() {
    this.syncState();
    this.update();
  },
  methods: {
    procedureIdToCategory(id) {
      if (id.endsWith('_REPLACED')) {
        return 'REPLACED'
      }
      return 'REMOVED';
    },
    procedureIdToClothing(id) {
      if (id.startsWith('ANY')) {
        return null;
      }
      return id.substring(0, id.lastIndexOf('_'));
    },
    stateToProcedureId(state) {
      if (state.clothing) {
        return state.clothing + '_' + state.category;
      }
      return 'ANY_EXPOSED_' + state.category;
    },
    syncState() {
      const data = this.getData(this.ikey);
      const id = get(data, 'id') || 'ANY_EXPOSED_REMOVED';
      this.state.category = this.procedureIdToCategory(id);
      this.state.clothing = this.procedureIdToClothing(id);
    },
    selectCategory(category) {
      this.state.category = category;
      this.update();
    },
    setClothing(area) {
      this.state.clothing = area;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'PROCEDURE',
        id: this.stateToProcedureId(this.state),
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
</style>
